import React, { useContext } from 'react';
import Chart from 'react-google-charts';

import { Card, CardHeader } from '@material-ui/core';
import DashboardContext from 'src/pages/Private/Dashboard/context';
import { defaultChartOptions } from 'src/utils/charts';

const PersonServiceSolicitationsChart: React.FC = () => {
  const {
    chartsInfo: { servicesSolicitationsIfbolsas },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        style={{ color: '#2D7EFB' }}
        title="IFBOLSAS"
        subheader="4 SERVIÇOS MAIS UTILIZADOS"
      />

      <Chart
        chartType="ColumnChart"
        data={servicesSolicitationsIfbolsas}
        options={defaultChartOptions}
      />
    </Card>
  );
};

export default PersonServiceSolicitationsChart;
